import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPrimevideoComponent } from './simple-icons-primevideo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPrimevideoComponent ],
    exports:      [ SimpleIconsPrimevideoComponent ],
    bootstrap:    []
})
export class SimpleIconsPrimevideoModule {}
